import { render, staticRenderFns } from "./TextAreaStyle-old.vue?vue&type=template&id=25fc4eb1"
import script from "./TextAreaStyle-old.vue?vue&type=script&lang=js"
export * from "./TextAreaStyle-old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports